export const PILL = 'PILL';
export const ICON = 'ICON';
export const DEFAULT = 'DEFAULT';